export var VariantPositionRibbon;
(function (VariantPositionRibbon) {
    VariantPositionRibbon["TOP_LEFT"] = "TOP_LEFT";
    VariantPositionRibbon["TOP_RIGHT"] = "TOP_RIGHT";
    VariantPositionRibbon["BOTTOM_LEFT"] = "BOTTOM_LEFT";
    VariantPositionRibbon["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
})(VariantPositionRibbon || (VariantPositionRibbon = {}));
export var VariantKey;
(function (VariantKey) {
    VariantKey["YELLOW"] = "YELLOW";
    VariantKey["RED"] = "RED";
    VariantKey["GREEN"] = "GREEN";
    VariantKey["GREY"] = "GREY";
    VariantKey["BLUE"] = "BLUE";
})(VariantKey || (VariantKey = {}));
export const getBorderRadiusWithRibbonAdjusted = (cornerRibbonPosition) => {
    switch (cornerRibbonPosition) {
        case 'TOP_LEFT':
            return { borderBottomLeftRadius: 0 };
        case 'TOP_RIGHT':
            return { borderBottomRightRadius: 0 };
        case 'BOTTOM_LEFT':
            return { borderTopLeftRadius: 0 };
        case 'BOTTOM_RIGHT':
            return { borderTopRightRadius: 0 };
        default:
            return {};
    }
};
